module.exports = {
  SENTRY_AUTH_TOKEN: '900a56cc6a064b45bc1ae8fa75a963fabfbc6f91ac4b4c87b3fa825736d022d8',
  RELEASE_VERSION: '3.01.00',
  ENVIRONMENT: 'production',
  SENTRY_ORG: 'kuaiyin',
  PROJECT_NAME: 'ky-h5',
};
